export default __webpack_public_path__ + "static/media/pu_logo.79cb4bb9.png";